import { PartnerGeschlecht } from '@mng/domain';
import {
  DependencyFunction,
  findObjectForPropertyInModelContext,
  findValueForPropertyInModelContext,
  IModelContext,
  jaOption,
  ModelDependency
} from '@mng/model';
import { getAlterForGeburtstag } from '@mng/mng-ts-helpers';
import { ITEM_PERSONEN_PERSON_ROLLEN } from '../../antrag.model.paths';
import { Person } from '../../antrag.model.types';
import { bufferedLogger } from '@mng/logging';

function findPerson(modelContext: IModelContext): Person {
  const person: Person = findObjectForPropertyInModelContext(modelContext, ITEM_PERSONEN_PERSON_ROLLEN);

  if (!person) {
    throw new Error('Person nicht gefunden');
  }
  return person;
}

export function isPersonImErstenLebensjahrDependencyFunction(
  dependency: ModelDependency,
  modelContext: IModelContext
): boolean {
  const person: Person = findPerson(modelContext);

  const alter =
    person && person.stammdaten && person.stammdaten.gebdatum ? getAlterForGeburtstag(person.stammdaten.gebdatum) : 30;
  bufferedLogger.log(
    modelContext.loggingStreamId,
    `[isPersonImErstenLebensjahrDependencyFunction] - Alter von ${person.stammdaten.name} ${person.stammdaten.vorname}: ${alter}`
  );

  return alter === 0;
}

export const TARIFKLASSE_ASSISTED_CARE_BEST = 'Assisted Care_Best';

export function isPersonAlterMindestens(
  dependency: ModelDependency,
  modelContext: IModelContext,
  mindestAlter: number
): boolean {
  const person: Person = findPerson(modelContext);
  const alter =
    person && person.stammdaten && person.stammdaten.gebdatum ? getAlterForGeburtstag(person.stammdaten.gebdatum) : 30;
  // console.log('isPersonImErstenLebensjahr', gvPerson, alter);
  return alter >= mindestAlter;
}

export function isPersonWeiblichDependencyFunction(dependency: ModelDependency, modelContext: IModelContext): boolean {
  const person: Person = findPerson(modelContext);
  return person.stammdaten && PartnerGeschlecht.W === person.stammdaten.geschlecht;
}

export function isPersonNotImErstenLebensjahrDependencyFunction(
  dependency: ModelDependency,
  modelContext: IModelContext
): boolean {
  const result = !isPersonImErstenLebensjahrDependencyFunction(dependency, modelContext);

  bufferedLogger.log(
    modelContext.loggingStreamId,
    `[isPersonNotImErstenLebensjahrDependencyFunction] - Returning: ${result}`
  );

  return result;
}

export function notHasPersonTarifklasseAssistedCareBestDependencyFunction(
  dependency: ModelDependency,
  modelContext: IModelContext
): boolean {
  const person: Person = findPerson(modelContext);
  // Skip Gesundheitsfragen iff all tariffs contain Assisted Case Best
  return !(person?.tarifKlassen?.includes(TARIFKLASSE_ASSISTED_CARE_BEST) && person?.gvEinzelTarifAbschluss);
}

export function isPersonMindestens18JahreDependencyFunction(
  dependency: ModelDependency,
  modelContext: IModelContext
): boolean {
  return isPersonAlterMindestens(dependency, modelContext, 18);
}

export function createOptionJaDependencyFunction(propertyName: string): DependencyFunction {
  return (dependency: ModelDependency, modelContext: IModelContext): boolean => {
    const jaNeinValue = findValueForPropertyInModelContext(modelContext, propertyName);

    const result = jaOption.value === jaNeinValue;

    // console.log('createOptionJaDependencyFunction modelContext', modelContext, jaOption.value, jaNeinValue, result);
    return result;
  };
}

export function createOptionTrueDependencyFunction(propertyName: string): DependencyFunction {
  return (dependency: ModelDependency, modelContext: IModelContext): boolean => {
    const booleanValue = findValueForPropertyInModelContext(modelContext, propertyName);
    const result = true === booleanValue;
    return result;
  };
}
